import React from 'react';

import { Anchor, SectionHeader, Spacer } from '@/components/common';
import Metric from '@/components/landingPage/metrics/metric/Metric';
import { Metrics as MetricsType } from '@/data/metrics';
import { fetchMetrics } from '@/data/metrics';
import { useCountUp, useInView } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import {
  calendarOutline,
  happyOutline,
  locationOutline,
  peopleOutline
} from 'ionicons/icons';

import './Metrics.css';

interface MetricsProps {
  showHeader?: boolean;
  header?: string;
}

const Metrics: React.FC<MetricsProps> = ({
  showHeader = true,
  header = 'Used by Thousands'
}) => {
  const { data } = useQuery<MetricsType, Error>({
    queryKey: ['metrics'],
    queryFn: fetchMetrics
  });

  const [ref, inView] = useInView({
    threshold: 0.24,
    triggerOnce: true
  });

  const requests = useCountUp({
    target: inView ? (data?.request_count ?? 0) : 0,
    format: true
  });
  const dentists = useCountUp({
    target: inView ? (data?.dentist_count ?? 0) : 0,
    format: true
  });
  const clinics = useCountUp({
    target: inView ? (data?.clinic_count ?? 0) : 0,
    format: true
  });
  const patients = useCountUp({
    target: inView ? (data?.patient_count ?? 0) : 0,
    format: true
  });

  return (
    <div className="metrics">
      <Anchor id="to-metrics" />
      {showHeader && <SectionHeader>{header}</SectionHeader>}
      <Spacer top={16} />
      <div className="metrics__container" ref={ref}>
        <Metric
          icon={calendarOutline}
          label="Appointments"
          value={requests}
          barType="appointments"
          inView={inView}
        />
        <Metric
          icon={happyOutline}
          label="Patients"
          value={patients}
          barType="patients"
          inView={inView}
        />
        <Metric
          icon={locationOutline}
          label="Clinics"
          value={clinics}
          barType="clinics"
          inView={inView}
        />
        <Metric
          icon={peopleOutline}
          label="Dentists"
          value={dentists}
          barType="dentists"
          inView={inView}
        />
      </div>
    </div>
  );
};

export default Metrics;
